export default __webpack_public_path__ + "static/media/row_circle_right.f1ec854c.svg";